$mol_icon $mol_svg_root
	view_box \0 0 24 24
	minimal_width 16
	minimal_height 16
	sub /
		<= Path $mol_svg_path
			geometry <= path \
